import * as React from 'react';
import Label from "./Label";

export default class VideoDuration extends React.PureComponent {
  render() {
    let { full_length: { duration } } = this.props;

    if (!duration) {
      return null;
    }

    return <Label vertical="bottom" horizontal="left" className="video-duration">
      { duration }
    </Label>;
  }
}